import {apiClient} from './axios';
import {
    AiImageGroup,
    AiImageGroupDetail,
    AiImageRequest,
    BaseImageUploadResponse,
    CreateAiImageGroupRequest,
    CreateAiImageRequestBody,
    UpdateAiImageGroupRequest,
} from '../types/aiImage';

export const aiImageApi = {
    // ── 그룹 ──────────────────────────────────────────────────────────────────
    listGroups: async (): Promise<AiImageGroup[]> => {
        const result = await apiClient.get<AiImageGroup[]>(
            '/admin/ai-images/groups'
        );
        return result ?? [];
    },

    createGroup: (body: CreateAiImageGroupRequest): Promise<AiImageGroup> =>
        apiClient.post<AiImageGroup>('/admin/ai-images/groups', body),

    // 백엔드 응답 타입은 AiImageGroupDetailResponse (그룹 메타 + 최근 20건 요청)
    getGroup: async (id: number): Promise<AiImageGroupDetail> => {
        const result = await apiClient.get<AiImageGroupDetail>(
            `/admin/ai-images/groups/${id}`
        );
        return {
            group: result.group,
            requests: result.requests ?? [],
        };
    },

    updateGroup: (
        id: number,
        body: UpdateAiImageGroupRequest
    ): Promise<AiImageGroup> =>
        apiClient.patch<AiImageGroup>(`/admin/ai-images/groups/${id}`, body),

    deleteGroup: (id: number): Promise<void> =>
        apiClient.delete<void>(`/admin/ai-images/groups/${id}`),

    // ── 요청 ──────────────────────────────────────────────────────────────────
    listRequests: async (groupId: number): Promise<AiImageRequest[]> => {
        const result = await apiClient.get<AiImageRequest[]>(
            `/admin/ai-images/groups/${groupId}/requests`
        );
        return result ?? [];
    },

    createRequest: (
        groupId: number,
        body: CreateAiImageRequestBody
    ): Promise<AiImageRequest> =>
        apiClient.post<AiImageRequest>(
            `/admin/ai-images/groups/${groupId}/requests`,
            body
        ),

    getRequest: (id: number): Promise<AiImageRequest> =>
        apiClient.get<AiImageRequest>(`/admin/ai-images/requests/${id}`),

    cancelRequest: (id: number): Promise<void> =>
        apiClient.postNoData(`/admin/ai-images/requests/${id}/cancel`).then(
            () => undefined
        ),

    // ── base image 업로드 (multipart) ─────────────────────────────────────────
    uploadBaseImage: async (
        groupId: number,
        file: File
    ): Promise<BaseImageUploadResponse> => {
        const form = new FormData();
        form.append('file', file);
        form.append('groupId', String(groupId));
        return apiClient.postMultipart<BaseImageUploadResponse>(
            '/admin/ai-images/base-image',
            form
        );
    },
};
